<template>
  <AdminMasterLayout>
    <div class="tank-wrapper">
      <!-- FIRST SECTION -->
      <section class="overhead">
        <div class="overhead-1 row justify-content-between py-5 wallet-header">
          <div class="col-md-6 col-sm-12">
            <h5 class="">{{ $t("text.iDashboard.tankConsumption") }}</h5>

            <h6>{{ $t("text.iDashboard.companyReportsDetails") }}</h6>
          </div>
        </div>
      </section>

      <!-- TABLE -->
      <section class="bg-white rounded table-section my-5">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="40" field="index" headerText="#"></e-column>
            <!-- <e-column field="date" width="180" headerText="Date"></e-column> -->
            <e-column
              :template="tankName"
              width="180"
              :headerText="$t('text.iDashboard.tank')"
            ></e-column>

            <e-column
              field="currentVolume"
              width="180"
              :headerText="$t('text.iDashboard.currentVolume')"
            ></e-column>
            <e-column
              field="maxCapacity"
              width="180"
              :headerText="$t('text.iDashboard.maxCapacity')"
            ></e-column>

            <!-- <e-column
              :template="tankAction"
              width="180"
              headerText="Action"
            ></e-column> -->
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </div>
  </AdminMasterLayout>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import tankName from "@/components/TableTemplates/IndustrialAdmin/tankName.vue";
import tankAction from "@/components/TableTemplates/IndustrialAdmin/tankAction.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
export default {
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  components: {
    AdminMasterLayout,
    Highcharts: Chart,
    TableLoader,
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      companyID: this.$route.query.companyID,
      companyCumulativeWallet: null,
      showLoader: false,
      isDisabled: true,
      tankDateRange: this.tankStartDate,
      hourlyPoweerConsumptionDateRange: this.hourlyConsumptionStartDate,
      totalGenHours: 0,
      totalPgHours: 0,
      tanks: [],
      consumptionstatus: "daily",
      year: "2020",
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      tankName: function () {
        return {
          template: tankName,
        };
      },
      tankAction: function () {
        return {
          template: tankAction,
        };
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      donutChart: {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
          },
        },
        title: {
          text: "Contents of Highsoft's weekly fruit delivery",
        },
        subtitle: {
          text: "3D donut in Highcharts",
        },
        plotOptions: {
          pie: {
            innerSize: 200,
            depth: 45,
            colors: ["#FCD462", "#370F70"],
          },
        },
        series: [
          {
            name: "Delivered amount",
            data: [
              ["Bananas", 8, "yellow"],
              ["Kiwi", 3],
            ],
          },
        ],
      },
    };
  },
  created() {
    this.getTanks();
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTanks();
      }
    },
  },
  methods: {
    changeYear(e) {
      this.year = e.target.value;
      this.getMonthlyUsageChart();
    },

    getTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Tanks/${this.$route.query.branchId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          // console.log(res.data);
          let index = 0;
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.currentVolume = el.currentVolume.toLocaleString();
            el.maxCapacity = el.maxCapacity.toLocaleString();
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          //   console.log(res);
        });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
.dashboard_chart {
  height: 500px;
}
.tank-wrapper {
  width: 95%;
  margin: auto auto;
}
wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}
</style>
